import { render, staticRenderFns } from "./LayoutSavitarna.vue?vue&type=template&id=e5e85fa8&scoped=true&"
import script from "./LayoutSavitarna.vue?vue&type=script&lang=js&"
export * from "./LayoutSavitarna.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSavitarna.vue?vue&type=style&index=0&id=e5e85fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e85fa8",
  null
  
)

export default component.exports